import type { Phase } from '../../types/domain';
import { workingDaysInPeriod } from '../dates';
import { toNumber } from '../numbers';

// Capacité d'une phase de régie (en jours) = nb devs × jours ouvrés de la période.
// Repli sur nbDevs × dureeMois × 20 si les dates ne sont pas renseignées.
export function timeAndMaterialsCapacity(phase: Phase): number {
  const nbDevs = toNumber(phase.nbDevs || 0);
  const periode = workingDaysInPeriod(phase.dateDebut, phase.dateFin);
  const base = periode > 0 ? periode : toNumber(phase.dureeMois || 0) * 20;
  return Math.round(nbDevs * base * 10) / 10;
}

export function soldDaysOfPhase(phase: Phase): number {
  return (phase.briques || []).reduce((s, b) => s + toNumber(b.joursVendus || 0), 0);
}

// Valeur "vendu" de référence pour une phase forfait (brique ou global) : le nombre committé côté
// CRM/fiche projet (jours_total) prime — c'est celui qui sert à planifier/répartir — sinon repli sur
// la somme des briques (utile juste après conversion, avant que la phase n'ait été renseignée).
export function phaseSoldDays(phase: Phase): number {
  const committed = toNumber(phase.joursTotal || 0) || 0;
  return committed > 0 ? committed : soldDaysOfPhase(phase);
}

// Écart entre le vendu committé (CRM/phase) et la somme des briques (alimentée par le champ Jira
// "temps vendu (en jours)" depuis l'auto-découverte des epics) — à consolider si significatif.
export function phaseSoldDivergence(
  phase: Phase,
): { committed: number; briques: number; diff: number } | null {
  const committed = toNumber(phase.joursTotal || 0) || 0;
  const briques = soldDaysOfPhase(phase);
  if (committed <= 0 || briques <= 0) return null;
  const diff = Math.round((committed - briques) * 10) / 10;
  return Math.abs(diff) > 0.5 ? { committed, briques, diff } : null;
}
